import mergeCapabilityPatch from '@shared/pieve/mergeCapabilityPatch.js';

export default mergeCapabilityPatch;
